module.exports = __webpack_public_path__ + "static/kevin-systrom-b4d7d7739c36deb048681a1fa63ef913.jpg";